import { useIntl } from 'react-intl';
import { Option } from '../components/questionnaire/inputs/SelectInput/SelectInput';
import countries from '../components/countries';

export default (lang?: string): Option[] => {
	const { locale } = useIntl();
	return Object.keys(countries.getAlpha3Codes()).map(code => ({
		value: code,
		label: countries.getName(code, lang || locale)
	}));
};
